var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SGPMainTabComponent',[_c('SGPTabComponent',{attrs:{"title":"Tarefas"}},[_c('TarefaMobilidadePage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }